<template>
    <div>

        <config-main-title>
            Tabelas
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-filter" 
                            type="select"
                            service="tipo-tabelas"
                            optionsMode="json"
                            optionsName="tipo-tabelas"
                            optionsData="id"
                            optionsDisplay="search"
                            :optionsList="[
                                { id: 'PRO', search: 'Procedimentos'},
                                { id: 'MIX', search: 'Materiais e Medicamentos'},
                                { id: 'OUT', search: 'Taxas'},
                            ]"
                            v-model="tipo"
                            @input="load ()" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-search" v-model="search" @onEnter="load()" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluirTabela ()">
                        Incluir Tabela
                    </button>
                </div>
            </div>

        </div>

        <div v-if="!lista || !lista.length">
            <az-empty-state 
                msg="Nenhum tabela identificado." 
                icon="fas fa-search" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2" v-if="dado.id_tabela_versao" title="Id">
                            #{{ dado.id_tabela_versao }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                            <a href="#" class="card-link" data-toggle="tooltip" data-placement="top" title="Operadoras Vinculadas" 
                                v-if="dado.tabela_operadoras && dado.tabela_operadoras.length"
                                @click.prevent="listOperadoras (dado)">
                                <span class="badge badge-secondary">
                                    {{ dado.tabela_operadoras ? dado.tabela_operadoras.length : '-'}}
                                </span>
                            </a>
                            <span v-else>
                                <a href="#" @click.prevent="vincular(dado)">
                                    <span class="text-warning" data-toggle="tooltip" data-placement="top" title="Nenhuma operadora vinculada">
                                        <i class="fas fa-exclamation-triangle"></i>
                                    </span>
                                </a>
                            </span>
                            <a href="#" @click.prevent="vincular(dado)" class="btn btn-outline-primary btn-sm ml-3">
                                <i class="fa-solid fa-link"></i>
                            </a>
                        </span>
                    </span>
                </li>
            </div>

        </div>

        <!--
        <pre class="alert alert-secondary">{{ lista }}</pre>
        <pre class="alert alert-warning">{{ dados }}</pre>
        -->
        <div v-if="em_edicao">

            <div class="row">
                <div class="col col-12">
                    <az-break-title class="mb-3" :title="tabela.st_nome" :qtd="'versão: ' + tabela.st_versao" :no_margin="true" :link="true" @click="editarTabela(tabela)">
                    </az-break-title>
                </div>
            </div>

            <importacao 
                ref="importmoeda"
                service="moedas" 
                :hide="true" 
                :parms="{ id_tabela_versao: tabela ? tabela.id_tabela_versao : null }" 
                v-if="tabela && tabela.id_tabela_versao" 
                @refresh="reloadTabela();" />

            <div class="alert alert-info" v-if="tabela.tabela_operadoras && tabela.tabela_operadoras.length">

                <div class="row" v-if="tabela.tabela_operadoras && tabela.tabela_operadoras.length">
                    <div class="col col-12 col-md-3">
                        {{ tabela.tabela_operadoras.length }} {{ tabela.tabela_operadoras.length > 1 ? 'operadoras relacionadas' : 'operadora relacionada' }}
                    </div>
                    <div class="col col-12 col-md-9 text-truncate">
                        {{ lista_operadoras(tabela) }}
                    </div>
                </div>

            </div>

            <div class="form-row">
                <div class="col col-12" :class="( tipo == 'PRO' ? 'col-md-3' : 'col-md-6' )">
                    <az-input icon="fas fa-search" v-model="searchItem" @input="buscarItems ()">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="tabela.id_tabela_versao">
                                <relatorios-linkados
                                    pagina="tabela-preco"
                                    :parms="{ id_tabela_versao: tabela.id_tabela_versao }" />
                            </div>

                            <button type="button" class="btn btn-outline-primary ml-1" @click="incluirItem ()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </template>
                    </az-input>
                </div>

                <div class="col col-12 col-md-3" v-if="tipo == 'PRO'">
                    <az-input icon="fas fa-filter"
                        type="select"
                        optionsMode="esp-ativas"
                        optionsName="esp-ativas"
                        :optionsReload="true"
                        placeholder="Especialidade..."
                        v-model="especialidade">
                    </az-input>
                </div>

                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewItemModeAtivo == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewItemModeAtivo = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewItemModeAtivo == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewItemModeAtivo = 'T'">
                            Todos
                        </button>
                    </div>
                </div>

                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewItemMode == 'V' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewItemMode = 'V'">
                            Vinculados
                        </button>
                        <button type="button" class="btn" :class="viewItemMode == 'N' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewItemMode = 'N'">
                            Não Vinc...
                        </button>
                        <button type="button" class="btn" :class="viewItemMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewItemMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

            <!-- Valores -->
            <div v-if="!items.data.length" class="mt-3">
                <az-empty-state 
                    :msg="'Nenhum item ' + ( viewItemMode == 'V' && !searchItem ? 'vinculado.' : 'identificado.' )" 
                    :icon="( viewItemMode == 'V' && !searchItem ? 'fas fa-link' : 'fas fa-search' )" />
            </div>

            <template v-else>

                <!-- Ajuste de itens da tabela -->
                <div class="card mt-3 w3-animate-opacity" v-if="tabela.editar_coluna">
                    <div class="card-header d-flex justify-content-between">
                        <span>Editar {{ tabela.editar_coluna.titulo }}</span>
                        <a href="#" @click.prevent="editarColuna()" class="card-link text-dark">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </a>
                    </div>
                    <div class="card-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-1 d-flex flex-column"
                                :class="tabela.editar_coluna.coluna == 'id_codigo_tabela' ? 'col-md-4' : 'col-md-1'">

                                <!-- Edição do código da tabela -->
                                <template v-if="tabela.editar_coluna.coluna == 'id_codigo_tabela'">
                                    <div>
                                        <az-input
                                            placeholder="Selecione o Código da Tabela..."
                                            type="select"
                                            optionsMode="aql"
                                            service="codigo_tabelas.index"
                                            optionsData="id_codigo_tabela"
                                            optionsDisplay="search"
                                            v-model="tabela.editar_coluna.id_codigo_tabela"
                                            required
                                            :validate="validate"  />
                                    </div>
                                </template>

                                <!-- Edição dos demais campos -->
                                <template v-else>
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                                        <i class="fas fa-plus fa-fw" v-if="ajuste_item == 'plus'"></i>
                                        <i class="fa fa-minus fa-fw" v-else-if="ajuste_item == 'minus'"></i>
                                        <i class="fas fa-edit fa-fw" v-else-if="ajuste_item == 'edit'"></i>
                                        <i class="fas fa-equals fa-fw" v-else-if="ajuste_item == 'tabela'"></i>
                                        <i class="fa-solid fa-link" v-else-if="ajuste_item == 'tablink'"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'plus'" v-if="tabela.editar_coluna.coluna.substr(0,3) == 'dc_'">
                                            <i class="fas fa-plus fa-fw mr-2"></i>Aumentar
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'minus'" v-if="tabela.editar_coluna.coluna.substr(0,3) == 'dc_'">
                                            <i class="fa fa-minus fa-fw mr-2" aria-hidden="true"></i>Reduzir
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'edit'" v-if="tabela.editar_coluna.coluna != 'moeda'">
                                            <i class="fas fa-edit fa-fw mr-2" aria-hidden="true"></i>Editar
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'tabela'">
                                            <i class="fas fa-equals fa-fw mr-2"></i>Tabela (pelo Código)
                                        </a>
                                        <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'tablink'">
                                            <i class="fa-solid fa-link fa-fw mr-2"></i>Tabela (pelo Procedimento)
                                        </a>
                                    </div>
                                </template>

                            </div>
                                
                            <div class="col col-12 col-md-3" v-if="tabela.editar_coluna.coluna != 'id_codigo_tabela'">

                                <az-input 
                                    v-if="ajuste_item == 'tabela' || ajuste_item == 'tablink'"
                                    icon="fas fa-list" 
                                    type="select" 
                                    :optionsList="lista_tabelas"
                                    optionsMode="json"
                                    v-model="ajuste_tabela"
                                    @input="buscar_items_ajuste_tabela()" />
                            
                                <az-input
                                    v-else
                                    icon="fa fa-percent"
                                    type="money"
                                    :edicao="ajuste_item != 'edit'"
                                    v-model="percentual_ajuste">
                                </az-input>

                            </div>

                            <div class="col col-12 col-md-2 d-flex flex-column">
                                <az-submit color="success" @click="efetivar_ajuste()">
                                    Atualizar
                                </az-submit>
                            </div>

                            <div class="col col-12 col-md-4 d-flex">
                                <button type="button" class="btn btn-outline-secondary mb-3 mr-2" 
                                    v-if="tabela.editar_coluna.coluna == 'dc_valor' && ajuste_item != 'tabela' && ajuste_item != 'tablink' && tabela.st_aplicacao != 'MIX'"
                                    @click="ajuste_data === null ? ajuste_data = '' : ajuste_data = null">
                                    <i class="fas fa-calendar-day"></i>
                                </button>
                                <az-input 
                                    v-if="ajuste_item != 'edit' || tabela.editar_coluna.coluna == 'id_codigo_tabela'"
                                    type="checkbox-group"
                                    label="Aplicar na tabela completa"
                                    v-model="ajustar_todos" />
                            </div>

                            <div class="col col-12 col-md-2 text-right" v-if="items.data.length > 1">
                                <span>
                                    <div>
                                        <span class="text-muted mr-1">Itens:</span>
                                        <span>{{ items.total }}</span>
                                    </div>
                                    <div>
                                        <span class="text-muted mr-1">Selecionados:</span>
                                        <span>{{ ajustar_todos && ajuste_item != 'edit' ? items.total : items.data.filter(item => item.aplicar).length }}</span>
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div class="form-row" v-if="tabela.editar_coluna.coluna == 'dc_valor' && ajuste_data !== null && ajuste_item != 'tabela' && ajuste_item != 'tablink'">
                            <div class="col col-12 col-md-3 offset-md-1">
                                <az-input
                                    type="date"
                                    icon="fas fa-calendar-day" 
                                    required
                                    :validate="validate"
                                    v-model="ajuste_data" />
                            </div>
                            <div class="col col-12 col-md-8">
                                <small class="text-muted">
                                    {{ ajuste_data ? $util.getHumanDuration(ajuste_data) : '' }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                

                <!-- Itens da Tabela -->
                <table class="table table-hover table-responsive-md bg-white mt-3 cabecalho-fixo">
                    <thead>
                        <tr>
                            <th></th>
                            <th>
                                <a href="#" class="card-link text-nowrap" 
                                    @click.prevent="editarColuna({ coluna: 'st_codigo', titulo: 'Código do Item', st_codigo: '' })">
                                    Código
                                    <i class="fas fa-pen ml-2"></i>
                                </a>
                            </th>
                            <th>Nome</th>
                            <th v-if="tabela.st_aplicacao != 'MIX'">
                                <a href="#" class="card-link text-nowrap" 
                                    @click.prevent="editarColuna({ coluna: 'id_codigo_tabela', titulo: 'Código da Tabela', id_codigo_tabela: '' })">
                                    Cód Tab.
                                    <i class="fas fa-pen ml-2"></i>
                                </a>
                            </th>
                            <th v-if="tabela.fl_tem_cirurgia" class="text-truncate text-nowrap">
                                <a href="#" class="card-link" 
                                    @click.prevent="editarColuna({ coluna: 'in_porte_anestesico', titulo: 'Porte Anest.' })">
                                    Porte Anest.
                                </a>
                            </th>
                            <th v-if="tabela.fl_tem_cirurgia">
                                <a href="#" class="card-link" 
                                    @click.prevent="editarColuna({ coluna: 'in_numero_auxiliares', titulo: 'Aux' })">
                                    Aux
                                </a>
                            </th>
                            <th v-if="!tabela.fl_moeda_corrente">
                                <a href="#" class="card-link" v-if="1 == 1"
                                    @click.prevent="editarColuna({ coluna: 'moeda', titulo: tabela.ch_tipo_tabela == 'C' ? 'Porte' : 'Moeda' })">
                                    {{ tabela.ch_tipo_tabela == 'C' ? 'Porte' : 'Moeda' }}
                                </a>
                                <span v-else>
                                    {{ tabela.ch_tipo_tabela == 'C' ? 'Porte' : 'Moeda' }}
                                </span>
                            </th>
                            <th class="text-right text-truncate text-nowrap">
                                <a href="#" class="card-link" 
                                    @click.prevent="editarColuna({ coluna: 'dc_valor', titulo: 'Valor' })">
                                    Valor
                                    <i class="fas fa-pen ml-2"></i>
                                </a>
                            </th>
                            <th class="text-right text-truncate text-nowrap" v-if="!tabela.fl_moeda_corrente">
                                <a href="#" class="card-link" 
                                    @click.prevent="editarColuna({ coluna: 'dc_custo_operacional', titulo: 'Custo Oper.' })">
                                    Custo Oper.
                                    <i class="fas fa-pen ml-2"></i>
                                </a>
                            </th>
                            <th class="text-right text-truncate text-nowrap" v-if="tabela.fl_tem_imagem">
                                <a href="#" class="card-link" 
                                    @click.prevent="editarColuna({ coluna: 'dc_filme', titulo: 'Filme' })">
                                    Filme
                                    <i class="fas fa-pen ml-2"></i>
                                </a>
                            </th>

                            <!-- Novo Ajuste Título -->
                            <template v-if="tabela.editar_coluna">
                                <th :class="tabela.editar_coluna.coluna.substr(0,3) == 'dc_' ? 'text-right' : ''" v-if="tabela.editar_coluna.coluna != 'id_codigo_tabela'">
                                    <span v-if="tabela.editar_coluna.titulo == 'Moeda'">
                                        Nova Moeda
                                    </span>
                                    <span v-else>
                                        Novo {{ tabela.editar_coluna.titulo }}
                                    </span>
                                </th>

                                <th v-if="!ajustar_todos || ajuste_item == 'edit'" class="text-right">
                                    <input type="checkbox" :checked="marcar_todos" @click="toggle_aplicar_todos()" />
                                </th>
                            </template>

                            <!-- Status -->
                             <template v-if="viewItemModeAtivo == 'T'">
                                <th>Status</th>
                            </template> 
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(valor, iv) in items.data" :key="iv">
                            <td class="text-nowrap">
                                <a href="#" class="card-link" @click.prevent="editarItem(valor)">
                                    <i class="fa fa-search fa-fw" aria-hidden="true" v-if="!valor.fl_ativo"></i>
                                    <i class="fas fa-pen fa-fw" v-else></i>
                                </a>
                                <a href="#" class="card-link text-danger" @click.prevent="selecao_remover(valor)" v-if="valor.fl_ativo">
                                    <i class="fas fa-trash-alt"></i>
                                </a>
                                <a href="#" class="card-link" @click.prevent="listProcedimentos(valor)">
                                    <span class="badge badge-secondary" data-toggle="tooltip" data-placement="top" 
                                        :title="tabela.st_aplicacao == 'OUT' ? 'Taxas Vinculadas' : 'Procedimentos Vinculados'">
                                        {{ valor.total_procedimentos }}
                                    </span>
                                </a>

                                <span class="badge badge-danger ml-2" v-if="!valor.fl_ativo">Inativo</span>
                            </td>
                            <td>{{ valor.st_codigo }}</td>
                            <td class="small">
                                {{ tabela.st_aplicacao == 'MIX' ? valor.st_descricao : valor.st_nome }}
                                <span v-if="valor.grau_participacao" class="badge badge-secondary ml-2">
                                    GP {{ valor.grau_participacao.st_codigo_tiss }}
                                </span>

                                <span class="badge badge-primary ml-2" v-if="tabela.st_aplicacao == 'MIX' && valor.ch_tipo_atualizacao">
                                    {{ valor.ch_tipo_atualizacao }}
                                </span>
                            </td>
                            <td v-if="tabela.st_aplicacao != 'MIX'">
                                <span data-toggle="tooltip" data-placement="top" :title="valor.codigo_tabela ? valor.codigo_tabela.st_descricao : ''">
                                    {{ valor.codigo_tabela ? valor.codigo_tabela.ch_codigo : '' }}
                                </span>
                            </td>
                            <td v-if="tabela.fl_tem_cirurgia">{{ valor.in_porte_anestesico }}</td>
                            <td v-if="tabela.fl_tem_cirurgia">{{ valor.in_numero_auxiliares }}</td>
                            <td v-if="!tabela.fl_moeda_corrente">{{ valor.moeda ? valor.moeda.search : 'R$' }}</td>
                            <td class="text-right">
                                {{ $util.formatMoeda(valor.dc_valor, 6, 2) }}
                                <div v-if="preco_programado(valor)">
                                    <small class='text-muted'>
                                        {{ preco_programado(valor) }}
                                    </small>
                                </div>
                            </td>
                            <td class="text-right" v-if="!tabela.fl_moeda_corrente">
                                <span v-if="valor.dc_custo_operacional > 0 && valor.moeda">
                                    {{ $util.formatNumber(valor.dc_custo_operacional, 3) }}
                                </span>
                            </td>
                            <td class="text-right" v-if="tabela.fl_tem_imagem">
                                <span v-if="valor.dc_filme > 0">
                                    {{ $util.formatNumber(valor.dc_filme, 4) }}
                                </span>
                            </td>

                            <!-- Novo Ajuste -->
                            <template v-if="tabela.editar_coluna">
                                <template v-if="tabela.editar_coluna.coluna == 'moeda'">
                                    <td>
                                        <span v-if="calc_valor_ajuste(valor)">
                                            {{ calc_valor_ajuste(valor).st_moeda }}
                                        </span>
                                    </td>
                                </template>

                                <template v-else-if="tabela.editar_coluna.coluna != 'id_codigo_tabela'">
                                    <td v-if="ajuste_item == 'edit'" :class="tabela.editar_coluna.coluna.substr(0,3) == 'dc_' ? 'float-right' : ''">
                                        <az-input
                                            style="max-width: 120px;"
                                            type="money"
                                            sizing="sm" 
                                            required 
                                            :validate="valor.aplicar && validate"
                                            :edicao="valor.aplicar"
                                            v-model="valor.novo_valor" />
                                    </td>
                                    <td :class="tabela.editar_coluna.coluna.substr(0,3) == 'dc_' ? 'text-right' : ''" v-else>
                                        <template v-if="tabela.editar_coluna.coluna.substr(0,3) == 'dc_'">
                                            {{ $util.formatMoeda(calc_valor_ajuste(valor)) }}
                                        </template>
                                        <template v-else>
                                            {{ calc_valor_ajuste(valor) }}
                                        </template>
                                    </td>
                                </template>

                                <td class="text-right" v-if="!ajustar_todos || ajuste_item == 'edit'">
                                    <input type="checkbox" v-model="valor.aplicar" />
                                </td>
                            </template>

                            <template v-if="viewItemModeAtivo == 'T'">
                                <td>
                                    <template v-if="valor.id_propria">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" 
                                                :id="'ativo-' + valor.id_propria" 
                                                v-model="valor.fl_ativo" 
                                                @change="toggle_propria(valor)">
                                            <label class="custom-control-label" :for="'ativo-' + valor.id_propria"></label>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" 
                                                :id="'ativo-' + valor.id_item_tabela" 
                                                v-model="valor.fl_ativo" 
                                                @change="toggle_item(valor)">
                                            <label class="custom-control-label" :for="'ativo-' + valor.id_item_tabela"></label>
                                        </div>
                                    </template>
                                </td>
                            </template>

                        </tr>
                    </tbody>
                    <tfoot v-if="1 == 0 && items.last_page > 1">
                        <tr>
                            <td colspan="1000">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        
                                    </div>
                                    <div>
                                        <nav>
                                            <paginate
                                                class="mb-0"
                                                :page-count="items.last_page"
                                                :container-class="'pagination'"
                                                :page-class="'page-item'"
                                                :page-link-class="'page-link'"
                                                :prev-class="'page-link'"
                                                :next-class="'page-link'"
                                                :prev-text="'<<'"
                                                :next-text="'>>'"
                                                :click-handler="paginar">
                                            </paginate>
                                        </nav>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </template>

            <br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3">
                <div class="d-flex">
                    <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                    <template v-if="items.last_page > 1">
                        <paginate
                            class="mb-0"
                            :page-count="items.last_page"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :prev-class="'page-link'"
                            :next-class="'page-link'"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :click-handler="paginar">
                        </paginate>
                    </template>

                    <div class="spinner-border ml-2" role="status" v-if="$store.state.loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div>
                    <!-- Vinculo SIMPRO / BRASÍNDICE -->
                    <span class="btn-group dropup" v-if="tabela && tabela.st_aplicacao == 'MIX'">
                        <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa-solid fa-link mr-2"></i>
                            Vincular
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="#" @click.prevent="iniciar_vinculo_matmed('B')">Brasíndice</a>
                            <a class="dropdown-item" href="#" @click.prevent="iniciar_vinculo_matmed('S')">Simpro</a>
                        </div>
                    </span>

                    <button type="button" class="btn btn-outline-primary ml-2" @click="editar_vinculo_operadoras()">
                        <i class="far fa-credit-card mr-2"></i>
                        Operadoras
                    </button>

                    <button type="button" class="btn btn-outline-primary ml-2" @click="editarMoedas ()" v-if="!tabela.fl_moeda_corrente">
                        Moedas
                        <span class="badge badge-primary" v-if="tabela && tabela.moedas && tabela.moedas.length">
                            {{ tabela.moedas.length }}
                        </span>
                    </button>
                    <button class="btn btn-outline-primary ml-2" @click="abrir_modal_vincular_tuss('AMB')" v-if="viewItemMode == 'T' && tabela && tabela.st_aplicacao == 'PRO'">
                        <i class="fa fa-link mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        Vincular / AMB
                    </button>
                    <button class="btn btn-outline-primary ml-2" @click="abrir_modal_vincular_tuss()" v-if="viewItemMode == 'T'">
                        <i class="fa fa-link mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        {{ ( tabela && tabela.st_aplicacao == 'MIX' ) ? 'Vincular / Código' : 'Vincular / TUSS' }} 
                    </button>

                    <div class="btn-group dropup ml-2">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-upload mr-2" aria-hidden="true" v-if="!carregando"></i>
                            <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                                <span class="sr-only">Loading...</span>
                            </div>
                            Importar
                        </button>
                        <div class="dropdown-menu">
                            <a href="#" @click.prevent="abrir_modal_importar()" class="dropdown-item">
                                Itens
                            </a>
                            <template v-if="!tabela.fl_moeda_corrente">
                                <a href="#" @click.prevent="$refs.importmoeda.iniciar_importacao()" class="dropdown-item">
                                    Moedas
                                </a>
                            </template>
                        </div>
                    </div>

                    <button class="btn btn-primary ml-2" @click="abrir_modal_importar()" v-if="false">
                        <i class="fa fa-upload mr-2" aria-hidden="true" v-if="!carregando"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                          <span class="sr-only">Loading...</span>
                        </div>
                        Importar
                    </button>
                </div>
            </nav>

        </div>

        <!-- Modal de Tabela -->
        <div class="modal fade" id="tabelaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Tabela</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="edicaoTabela">
                            <div class="row">
                                <div class="col">
                                    <az-input 
                                        label="Nome da Tabela"
                                        :edicao="!edicaoTabela.clonar"
                                        v-model="edicaoTabela.st_nome" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <az-input 
                                        label="Versão"
                                        :edicao="!edicaoTabela.clonar"
                                        v-model="edicaoTabela.st_versao" />
                                </div>
                            </div>

                            <template v-if="edicaoTabela.st_aplicacao == 'PRO'">
                                <template v-if="!edicaoTabela.clonar">
                                    <az-sub-title class="mt-3" title="Opções"/>
                                    <div class="row">
                                        <div class="col">
                                            <az-input
                                                type="checkbox-group" 
                                                label="Valores somente em R$"
                                                v-model="edicaoTabela.fl_moeda_corrente" />
                                        </div>
                                    </div>
                                    <div class="row mb-2" v-if="!edicaoTabela.fl_moeda_corrente">
                                        <div class="col">
                                            <az-input
                                                label="Valor da UCO"
                                                type="money" 
                                                :precision="4"
                                                v-model="edicaoTabela.dc_valor_uco" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <az-input
                                                type="checkbox-group" 
                                                label="Procedimentos de Imagem"
                                                v-model="edicaoTabela.fl_tem_imagem" />
                                        </div>
                                    </div>
                                    <div class="row mb-2" v-if="edicaoTabela.fl_tem_imagem">
                                        <div class="col">
                                            <az-input
                                                label="Valor do Filme (m)"
                                                type="money" 
                                                v-model="edicaoTabela.dc_valor_filme" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <az-input
                                                type="checkbox-group" 
                                                label="Procedimentos Cirúrgicos"
                                                v-model="edicaoTabela.fl_tem_cirurgia" />
                                        </div>
                                    </div>
                                </template>
                            
                            </template>

                            <!-- Clonar Tabela -->
                            <template v-if="edicaoTabela.clonar">
                                <az-sub-title class="mt-3" title="Clonar"/>
                                <div class="row">
                                    <div class="col">
                                        <az-input 
                                            label="Nome da Nova Tabela"
                                            required
                                            :validate="validate"
                                            v-model="edicaoTabela.novo_nome" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <az-input 
                                            label="Versão da Nova Tabela"
                                            required
                                            :validate="validate"
                                            v-model="edicaoTabela.nova_versao" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col">
                                        <az-input 
                                            type="button-group"
                                            label="Apenas Vinculados"
                                            :optionsList="[
                                                {id:'V',search:'Apenas Vinculados'}, 
                                                {id:'T',search:'Todos' }
                                            ]"
                                            v-model="edicaoTabela.apenas_vinculados" />
                                    </div>
                                </div>

                            </template>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <template v-if="edicaoTabela && edicaoTabela.st_aplicacao == 'PRO' && !edicaoTabela.id_tabela_versao">
                            <button class="btn btn-outline-primary" @click="selecionar_base()">
                                <i class="fas fa-list-alt"></i>
                                Tabela Referencial
                            </button>
                        </template>
                    
                        <template v-if="edicaoTabela && ( 1 == 1 || edicaoTabela.st_aplicacao == 'PRO' ) && edicaoTabela.id_tabela_versao">
                            <button type="button" class="btn btn-outline-primary" v-if="!edicaoTabela.clonar" @click="clonar()">
                                <i class="far fa-clone mr-2"></i>
                                Clonar
                            </button>
                            <button type="button" class="btn btn-outline-secondary" v-else @click="clonar(false)">
                                <i class="fa fa-times mr-2" aria-hidden="true"></i>
                                Cancelar Clonar
                            </button>
                        </template>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="edicaoTabela" @click="atualizarTabela ()">{{ edicaoTabela.clonar ? 'Clonar' : 'Atualizar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        

        <!-- Modal de Procedimentos Relacionados -->
        <div class="modal fade" id="procedimentosModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="itemTabela && procedimentos">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item.st_aplicacao == 'OUT' ? 'Taxas Relacionadas' : 'Procedimentos Relacionados' }} 
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="lead mb-3">{{ itemTabela.search }}</div>

                        <div class="list-group" v-for="(proc, ip) in procedimentos" :key="ip">
                            <a href="#" class="list-group-item list-group-item-action" @click.prevent="$util.abrirProcedimento(proc.procedimento)">
                                {{ proc.item.search }}
                            </a>
                        </div>

                        <div v-if="!procedimentos.length"> 
                            Nenhum(a) {{ tipoTabela (tabela, false) }} vinculado(a).
                        </div>

                        <pre v-if="1 == 0">{{ itemTabela }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Operadoras Relacionadas -->
        <div class="modal fade" id="operadorasModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="tabela">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Operadoras Relacionadas
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="lead mb-3">{{ tabela.search }}</div>

                        <div class="list-group" v-for="(tabela_operadora, iop) in tabela.tabela_operadoras" :key="iop">
                            <a href="#" class="list-group-item list-group-item-action" 
                                @click.prevent="$util.abrirOperadora(tabela_operadora.operadora, 'Tabelas e Valores')">
                                {{ tabela_operadora.operadora.search }}
                                <span v-if="tabela_operadora.plano"> / {{ tabela_operadora.plano.st_plano }} (#{{ tabela_operadora.id_plano }})</span>
                                <span v-else>(#{{ tabela_operadora.id_operadora }})</span>
                            </a>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Vinculo Operadoras -->
        <div class="modal fade" id="editVinculoOperadorasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="tabela">
                    <div class="modal-header">
                        <h5 class="modal-title">Tabela: {{ tabela.st_nome }}
                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                            Vínculo Operadora
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'I', search: 'Incluir' },
                                { id: 'R', search: 'Remover' }
                            ]"
                            optionsData="id"
                            v-model="tipo_edicao_operadoras" />

                        <div v-if="tipo_edicao_operadoras == 'I'" class="mt-3">

                            <div class="alert alert-success mt-3">
                                Marque as operadoras que deseja incluir o vínculo com a tabela.
                            </div>

                            <div class="form-row mb-3">
                                <div class="col col-12 col-md-9">
                                    <az-input
                                        sizing="sm"
                                        icon="fa fa-search" 
                                        placeholder="Pesquisar..."
                                        v-model="search_vinc_oper">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" v-if="tipo_edicao_operadoras == 'I'">
                                                    {{ lista_base_operadoras_filtrada.filter(item => item.selecionado).length }} / {{ lista_base_operadoras_filtrada.length }}
                                                </span>
                                                <button type="button" class="btn btn-outline-primary" v-if="lista_base_operadoras_filtrada.length" @click="marcar_vinc_oper_todos()">
                                                    Todos
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        sizing="sm"
                                        type="button-group" 
                                        :optionsList="[
                                            { id: 'T', search: 'Todos' },
                                            { id: 'S', search: 'Selecionados' },
                                        ]"
                                        v-model="tipo_exibicao_lista_oper" />
                                </div>
                            </div>

                            <table class="table table-sm border-0 table-responsive">
                                <tr>
                                    <td class="text-nowrap">
                                        <a href="#" @click.prevent="filtrar_vinculo_operadora(classe)" v-for="(classe, icx) in lista_operadora_classes" :key="icx">
                                            <span class="badge badge-success mr-1">
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <az-empty-state v-if="!lista_base_operadoras_filtrada || !lista_base_operadoras_filtrada.length" msg="Nenhuma operadora identificada" />

                            <div v-else>

                                <div class="form-row mb-1">
                                    <div class="col col-12 col-md-9">
                                        <az-input 
                                            sizing="sm"
                                            placeholder="Título..." 
                                            required
                                            :validate="validate"
                                            v-model="dados_vinc_oper.titulo" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input 
                                            sizing="sm"
                                            type="number"
                                            placeholder="Ordem..."
                                            :validate="validate"
                                            v-model="dados_vinc_oper.ordem" />
                                    </div>
                                </div>

                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(tabope, tox) in lista_base_operadoras_filtrada" :key="tox">
                                        <div>
                                            <input type="checkbox" class="mr-3" v-model="tabope.selecionado" />
                                            {{ tabope.st_operadora }}
                                        </div>
                                        <div v-if="tabope.js_classes && tabope.js_classes.length">
                                            <a href="#" @click.prevent="filtrar_vinculo_operadora(classe)" v-for="(classe, icx) in tabope.js_classes" :key="icx">
                                                <span class="badge badge-success ml-1">
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div v-else>
                            <div class="alert alert-danger mt-3">
                                Marque as operadoras que deseja remover o vínculo com a tabela.
                            </div>

                            <ul class="list-group">
                                <li class="list-group-item" v-for="(tabope, tox) in tabela.tabela_operadoras" :key="tox">
                                    <input type="checkbox" class="mr-3" v-model="tabope.selecionado" />
                                    {{ tabope.operadora.st_operadora }}
                                </li>
                            </ul>

                        </div>

                        <pre v-if="false">{{ lista_unidade_operadora }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_vinc_oper()" v-if="tipo_edicao_operadoras == 'I'">Incluir</az-submit>
                        <az-submit color="danger" @click="atualizar_vinc_oper()" v-else>Remover</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Moedas -->
        <div class="modal fade" id="moedasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Moedas</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="moedas">
                            <div class="row" v-for="(moeda, imx) in lista_moedas" :key="imx">
                                <div class="col col-12 col-md-8">
                                    <az-input 
                                        sizing="sm"
                                        required 
                                        :validate="validate"
                                        icon="fas fa-minus"
                                        buttonText="fas fa-minus" 
                                        :buttonIcon="true" 
                                        buttonColor="outline-danger"
                                        @clickButton="remover_moeda(moeda)"
                                        v-model="moeda.st_moeda">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="moeda.item_tabelas_count">
                                                <span class="input-group-text" id="basic-addon2" data-toggle="tooltip" data-placement="top" title="Itens relacionados">
                                                    {{ moeda.item_tabelas_count }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        :type="removendo_moeda ? 'number' : 'money'"
                                        icon="fas fa-dollar-sign"
                                        :precision="6"
                                        required 
                                        :validate="validate"
                                        v-model="moeda.dc_valor" />
                                </div>
                            </div>
                            <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="incluirMoeda ()">
                                <i class="fas fa-plus"></i>
                            </button>

                            <hr>

                            <az-input
                                type="autocomplete"
                                optionsMode="aql"
                                optionsSync2="false"
                                service="tabela_versaos.index"
                                optionsData="id_tabela_versao"
                                :optionsParm="{ copiar_moedas: true }"
                                :optionsReload="true"
                                label="Copiar de..."
                                v-model="copia_origem"
                                @input="copiar_moedas_de()" />

                            <br><br><br><br><br><br><br><br>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizarMoedas()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <cadastro-item-tabela ref="cadtab" />

        <!-- Modal -->
        <div class="modal fade" id="importarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Importar</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="importados">
                        <p class="alert alert-primary">{{ importados.length - 1 }} {{ importados.length - 1 > 1 ? 'registros' : 'registro' }}</p>
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between hover-bg" :class="import_colunas[key] || import_colunas[key] === 0 ? 'list-group-item-success' : ''" 
                                v-for="(imp, key, ipx) in lista_import_colunas" :key="ipx">
                                <div>
                                    <div>{{ key.substr(3) == 'moeda' ? 'moeda / porte' : key.substr(3) }}</div>
                                    <small class="text-muted" v-if="import_colunas[key] !== null && import_colunas[key] != 'fixo' && importados.length > 1">
                                        {{ importados[1][import_colunas[key]] }}
                                    </small>
                                </div>
                                <div class="form form-inline">
                                    <input class="form form-control mr-1" v-if="import_colunas[key] !== null && import_colunas[key] == 'fixo'"
                                        placeholder="Importar..." v-model="fixos[key]">
                                    <select class="form form-control" v-if="importados && importados.length > 0"
                                            v-model="import_colunas[key]">
                                        <option></option>
                                        <option value="fixo">[Fixo]</option>
                                        <option v-for="(ci, cix) in importados[0]" :key="cix" :value="cix">
                                            {{ ci }}
                                        </option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div style="width: 320px;">
                            <template v-if="perc_import !== null">
                                <div>{{ perc_import }}%</div>
                                <div class="progress" style="height: 20px;">
                                <div class="progress-bar" role="progressbar" :style="'width: ' + perc_import + '%'"></div>
                                </div>
                            </template>
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit color="primary ml-2" @click="importar(false)">Atualizar</az-submit>
                            <az-submit color="primary ml-2" @click="importar(true)">Incluir e Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="importBaseModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione a Tabela</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state msg="Nenhuma tabela de referência localizada." v-if="!tabelas_base || !tabelas_base.length" />

                        <template v-else>

                            <template v-if="incluindo_tabela_referencia">
                                <p class="alert alert-info">Incluido {{ incluindo_tabela_referencia.st_nome }}...</p>
                            </template>

                            <div class="list-group" v-else>
                                <button type="button" class="list-group-item list-group-item-action" v-for="(tab, itx) in tabelas_base" :key="itx"
                                    @click="incluir_tabela_base(tab)" :disabled="$store.state.loading">
                                    {{ tab.st_nome }}
                                </button>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            <div class="spinner-border spinner-border-sm" role="status" v-if="$store.state.loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="arquivoImportarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Importar Tabela</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <ul class="list-group">
                            <li class="list-group-item">A importação deve ser feita de arquivo no formato CSV. Se o arquivo estiver no formato Excel, deve-se abri-lo no Excel e exportá-lo para CSV.</li>
                            <li class="list-group-item">Deve ser observado também se os títulos das colunas estão na primeira linha. Se o arquivo tiver linhas antes do título com outras informações, essas linhas devem ser apagadas para realizar a importação.</li>
                        </ul>

                        <div class="mt-3">
                            <az-input 
                                type="checkbox-group"
                                sizing="sm"
                                label="Importar Separado Mesmo Código, Descrição Diferente"
                                v-model="import_descr_diferente" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="upload()">Selecionar Arquivo</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="vincularTUSSModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Vincular</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row mb-2">
                            <template v-if="tabela && tabela.st_aplicacao == 'PRO'">
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        placeholder="Especialidades..."
                                        sizing="sm"
                                        icon="fas fa-filter fa-fw"
                                        type="select"
                                        optionsMode="esp-ativas"
                                        optionsName="esp-ativas"
                                        :optionsReload="true"
                                        optionsData="id_especialidade"
                                        v-model="filtro_vinc.id_especialidade" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        icon="fa-solid fa-object-ungroup fa-fw"
                                        sizing="sm"
                                        placeholder="Classificação..."
                                        type="select"
                                        optionsData="id_classe_procedimento"
                                        service="classe_procedimentos.index"
                                        optionsMode="aql"
                                        v-model="filtro_vinc.id_classe_procedimento" />
                                </div>
                            </template>
                            <div class="col col-12" :class="( tabela && tabela.st_aplicacao == 'PRO' ) ? 'col-md-4' : ''">
                                <az-input
                                    sizing="sm"
                                    placeholder="Pesquisar..."
                                    icon="fa fa-search fa-fw"
                                    v-model="filtro_vinc.pesquisa" />
                            </div>
                        </div>

                        <template v-if="!lista_vincular_exibicao || !lista_vincular_exibicao.length">
                            <az-empty-state msg="Nenhum item identificado." />
                        </template>
                        
                        <template v-else>
                            <p class="alert alert-info d-flex justify-content-between">
                                <a href="#" @click.prevent="marcar_todos_vinculo()" class="btn btn-sm btn-outline-info mr-3">
                                    Todos
                                </a>

                                <span>{{ lista_vincular_exibicao.filter(item => item.selec).length }} / {{ lista_vincular_exibicao.length }}</span>
                            </p>
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(item_vinc, ivx) in lista_vincular_exibicao" :key="ivx">
                                    <div>
                                        <input type="checkbox" class="mr-3" v-model="item_vinc.selec">
                                        <span class="badge badge-secondary mr-2">{{ item_vinc.st_codigo_cbhpm }}</span>
                                        {{ item_vinc.search }}
                                        <span v-if="item_vinc.st_id_externo">
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ item_vinc.st_id_externo }}
                                        </span>
                                        <span v-if="item_vinc.st_sigla" class="badge badge-secondary ml-2">
                                            {{ item_vinc.st_sigla }}
                                        </span>
                                    </div>
                                    <div>
                                        {{ item_vinc.st_codigo ? item_vinc.st_codigo : item_vinc.st_codigo_cbhpm }}
                                    </div>
                                </li>
                            </ul>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" :disabled="$store.state.loading" v-if="tabela && tabela.st_aplicacao != 'MIX'"
                            @click="abrir_modal_vincular_tuss('S')">
                            Vincular pela Sigla vs Observação
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="save_vinc_tuss()">Vincular</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Vinculo SIMPRO / BRASÍNDICE -->
        <div class="modal fade" id="vinculoMatMedModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="vinc_mat">
                    <div class="modal-header">
                        <h5 class="modal-title">Vincular {{ vinc_mat.ch_tipo_atualizacao == 'S' ? 'SIMPRO' : 'BRASÍNDICE' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="vinc_mat.items && !vinc_mat.items.length">
                            <az-empty-state msg="Nenhum item idenificado para vincular pelo código." icon="fa-solid fa-link" />
                        </template>

                        <template v-else>
                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Valor"
                                        :validate="validate"
                                        type="select"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        :optionsList="opcoesAtualizacaoValores(vinc_mat.ch_tipo_atualizacao)"
                                        required
                                        v-model="vinc_mat.ch_atualizacao_valor" />
                                </div>

                                <div class="col col-12 col-md-4" v-if="vinc_mat.ch_tipo_atualizacao != 'S'">
                                    <az-input
                                        type="select"
                                        sizing="sm"
                                        optionsMode="aql"
                                        optionsSync2="false"
                                        service="tabela_versaos.index"
                                        optionsData="id_tabela_versao"
                                        :optionsParm="{ brasindice: true }"
                                        optionsName="tabela_versaos.index.brasindices"
                                        :optionsReload="true"
                                        label="Seleciona a versão"
                                        v-model="id_tabela_versao_bra"
                                    />
                                </div>

                                <div class="col col-12 col-md-4" v-else>
                                    <az-input
                                        type="select"
                                        sizing="sm"
                                        optionsMode="aql"
                                        optionsSync2="false"
                                        service="tabela_versaos.index"
                                        optionsData="id_tabela_versao"
                                        :optionsParm="{ simpro: true }"
                                        optionsName="tabela_versaos.index.simpro"
                                        :optionsReload="true"
                                        label="Seleciona a versão"
                                        v-model="id_tabela_versao_sim"
                                    />
                                </div>

                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="Índice de atualização"
                                        :validate="validate"
                                        :precision="4"
                                        type="money"
                                        v-model="vinc_mat.dc_indice_atualizacao" />
                                </div>
                            </div>

                            <ul class="list-group mt-3">
                                <li class="list-group-item" v-for="(item, idx) in vinc_mat.items" :key="idx">
                                    {{ item.st_codigo }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ item.st_descricao }}
                                    <span class="badge badge-primary ml-2" v-if="item.ch_tipo_atualizacao">
                                        {{ item.ch_tipo_atualizacao }}
                                    </span>
                                </li>
                                <li class="list-group-item" v-if="vinc_mat.excedido">
                                    <i class="fa-solid fa-ellipsis"></i>
                                </li>
                            </ul>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="vincular_matmed()" v-if="vinc_mat.items && vinc_mat.items.length">Vincular</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <vincular-tabela-operadora ref="vinc" @refresh="load()" />

        <!-- Dispatch / @chunkRefresh="refresh_chunk" -->
        <az-dispatch
            name="vinc_tuss"
            ref="dispatchModal"
            titulo="Vínculo..."
            @refresh="finalizar_vinc_tuss()" />


    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzBreakTitle from '../../util/AzBreakTitle.vue';
import CadastroItemTabela from '../shared/CadastroItemTabela.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';
import VincularTabelaOperadora from './VincularTabelaOperadora.vue';
import Importacao from '../shared/Importacao.vue';
import AzDispatch from '../../util/AzDispatch.vue';
import * as CSV from 'csv-string';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            items: null, 
            procedimentos: null, 
            validate: false,
            especialidade: "",
            search: "", 
            searchItem: "", 
            viewMode: "A",
            viewItemMode: "V",
            viewItemModeAtivo: "A", 
            tipo: "PRO", 
            tabela: null, 
            edicaoTabela: null, 
            itemTabela: null, 
            pesquisar_debounce: null, 
            moedas: null, 
            link: false, 
            percentual_ajuste: 0,
            ajuste_item: "plus",
            ajustar_todos: true, 
            ajuste_tabela: "",
            ajuste_data: null, 
            lista_tabelas: [],
            carregando: false, 
            importados: null, 
            import_colunas: { 
                st_codigo: "",
                st_nome: "",
                dc_valor: "",
                in_porte_anestesico: "",
                in_numero_auxiliares: "",
                dc_custo_operacional: "",
                dc_filme: "",
                id_moeda: "",
                in_incidencia: "",
                st_unidade_radiofarmaco: "", 
                id_procedimento: "", 
                st_observacoes: "", 
                st_unidade: "",
                id_codigo_tabela: "", 
                id_codigo_despesa: "",
                dc_valor_coop: "", 
            },
            teste: null, 
            fixos: {},
            perc_import: null, 
            tabelas_base: null, 
            incluindo_tabela_referencia: false, 
            removendo_moeda: false, 
            lista_vincular: null, 
            copia_origem: "", 
            tipo_edicao_operadoras: "I",
            lista_base_operadoras: null, 
            search_vinc_oper: "", 
            tipo_exibicao_lista_oper: "T", 
            dados_vinc_oper: { 
                titulo: "", 
                ordem: "", 
            },
            vinc_mat: { 
                ch_atualizacao_valor: "",
                ch_tipo_atualizacao: "", 
                items: [], 
                excedido: false, 
            },
            filtro_vinc: { 
                id_especialidade: "",
                id_classe_procedimento: "",
                pesquisa: "", 
            },
            id_tabela_versao_sim: null,
            id_tabela_versao_bra: null,
            page: null, 
            import_descr_diferente: false, 
        }
    },

    props: ['id_tabela_versao', 'id_item_tabela'], 

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzBreakTitle,
        CadastroItemTabela,
        RelatoriosLinkados,
        VincularTabelaOperadora, 
        Importacao, 
        AzDispatch, 
    },

    watch: { 
        especialidade: function () { 
            this.reloadItems ();
        },

        viewItemMode: function () { 
            this.reloadItems ();
        },

        viewItemModeAtivo: function () { 
            this.reloadItems ();
        }
    },
    
    computed: { 
        lista_vincular_exibicao: function () { 
            if ( !this.lista_vincular )
                return [];

            let reg = this.$util.getregex(this.filtro_vinc.pesquisa);

            return this.lista_vincular.filter(item => !this.filtro_vinc.id_especialidade || item.id_especialidade == this.filtro_vinc.id_especialidade)
                .filter(item => !this.filtro_vinc.id_classe_procedimento || item.id_classe_procedimento == this.filtro_vinc.id_classe_procedimento)
                .filter(item => reg.test(JSON.stringify(item)));
        },

        lista_base_operadoras_filtrada: function () { 
            if ( !this.lista_base_operadoras )
                return [];

            let reg = this.$util.getregex(this.search_vinc_oper);

            return this.lista_base_operadoras.filter(item => !this.search_vinc_oper || reg.test(JSON.stringify(item)))
                .filter(item => this.tipo_exibicao_lista_oper == 'T' || item.selecionado);
        },

        lista_operadora_classes: function () { 
            if ( !this.lista_base_operadoras )
                return [];

            return _.uniq(
                this.lista_base_operadoras.filter(item => item.js_classes)
                    .flatMap(item => item.js_classes)
                    .sort()
            );
        },

        lista_import_colunas: function () { 
            let teste = _.pickBy(this.import_colunas, (item, chave) => { 
                return ( chave != 'in_porte_anestesico' || this.tabela.fl_tem_cirurgia ) && 
                    ( chave != 'in_numero_auxiliares' || this.tabela.fl_tem_cirurgia ) && 
                    ( chave != 'dc_filme' || this.tabela.fl_tem_imagem ) && 
                    ( chave != 'dc_custo_operacional' || !this.tabela.fl_moeda_corrente ) && 
                    ( chave != 'id_moeda' || !this.tabela.fl_moeda_corrente );
            });
            
            return teste;
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.search > b.search ? 1 : -1 ;
                }) : null;
        },

        lista_moedas: function () { 
            return _.orderBy(
                _.orderBy(
                    this.moedas.filter(item => item.fl_ativo),
                    'st_moeda'
                ),
                (item) => {
                    if ( !item.id_moeda )
                        return 999999;

                    let numbers = item.st_moeda.replace(/[^0-9]/g, ''); 
                    return numbers ? parseInt(numbers) : 0;
                });
        },

        marcar_todos: function() { 
           return this.items.data.findIndex(item => !item.aplicar) < 0;
        }
    },

    methods: { 
        toggle_propria (item) { 
            this.$util.toggle(this, { 
                service: 'proprias',
                dados: item,
            });
        },

        toggle_item (item) { 
            this.$util.toggle(this, { 
                service: 'item_tabelas',
                dados: item,
            });
        },

        vincular_matmed () { 
            const id_versao_bras_sim = this.vinc_mat.ch_tipo_atualizacao == 'S' ? this.id_tabela_versao_sim : this.id_tabela_versao_bra;

            if(!this.vinc_mat.ch_atualizacao_valor) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione o tipo de valor de atualização.",
                    life: 3000
                });
                return;
            }

            if(!id_versao_bras_sim) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione a versão para vincular.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: 'tabelas', 
                func: 'vincular_matmed_simpro_brasindice', 
                dados: { 
                    id_tabela_versao: this.tabela.id_tabela_versao, 
                    ch_tipo_atualizacao: this.vinc_mat.ch_tipo_atualizacao,
                    ch_atualizacao_valor: this.vinc_mat.ch_atualizacao_valor,
                    dc_indice_atualizacao: this.vinc_mat.dc_indice_atualizacao, 
                    id_versao_bras_sim: id_versao_bras_sim,
                },
                modal: 'vinculoMatMedModal', 
                toast: true, 
            });
        },

        opcoesAtualizacaoValores(tipo) {
            if(tipo == "B") {
                return [
                    { id: '1', search: 'PFB' },
                    { id: '2', search: 'PFB Fracionado' },
                    { id: '3', search: 'PMC' },
                    { id: '4', search: 'PMC Fracionado' },
                ]
            } else {
                return [
                    { id: '1', search: 'Preço Fabrincante Embalagem' },
                    { id: '2', search: 'Preço Fabrincante Fracionado' },
                    { id: '3', search: 'Preço Venda Embalagem' },
                    { id: '4', search: 'Preço Venda Fracinado' },
                    { id: '5', search: 'Preço Usuário Embalagem' },
                    { id: '6', search: 'Preço Usuário Fracionado' },
                ]
            }
        },

        iniciar_vinculo_matmed (tipo) { 
            this.validate = false;
            this.vinc_mat.ch_tipo_atualizacao = tipo;
            this.vinc_mat.items = [];

            $('#vinculoMatMedModal').modal('show');

            this.$util.load(this, { 
                service: 'tabelas',
                func: 'lista_vinculo_mat', 
                parms: { 
                    id_tabela_versao: this.tabela.id_tabela_versao, 
                    ch_tipo_atualizacao: tipo, 
                }, 
                loadTo: res => { 
                    this.vinc_mat.excedido = ( res.length > 20 ? true : false );
                    this.vinc_mat.items = res.slice(0,20);
                }
            });
        },

        finalizar_vinc_tuss() {
            $('.modal').modal('hide');

            this.reloadItems();

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Processo concluído.",
                life: 3000
            });
        },

        atualizar_vinc_oper () { 
            this.$util.atualizar(this, { 
                service: 'tabelas',
                func: 'vinc_oper', 
                dados: { 
                    id_tabela_versao: this.tabela.id_tabela_versao,
                    tipo: this.tipo_edicao_operadoras,
                    lista: this.tipo_edicao_operadoras == 'I'
                        ? this.lista_base_operadoras_filtrada.filter(item => item.selecionado)
                        : this.tabela.tabela_operadoras.filter(item => item.selecionado),
                    ...this.dados_vinc_oper, 
                },
                modal: 'editVinculoOperadorasModal',
                callback: this.reloadItems, 
            });
        },

        marcar_vinc_oper_todos () { 
            let selec = this.lista_base_operadoras_filtrada.find(item => item.selecionado) ? false : true;

            this.lista_base_operadoras_filtrada.forEach(item => { 
                item.selecionado = selec;
            });
        },

        filtrar_vinculo_operadora (texto) { 
            if ( this.search_vinc_oper == '"' + texto + '"' ) { 
                this.search_vinc_oper = "";
            } else { 
                this.search_vinc_oper = '"' + texto + '"';
            }    
        },

        editar_vinculo_operadoras () { 
            this.lista_base_operadoras = null;
            this.validate = false;
            this.tipo_edicao_operadoras = 'I';
            this.tipo_exibicao_lista_oper = 'T';

            this.$util.load(this, {
                service: 'operadoras',
                func: 'index',
                parms: {
                    cadastro_tabela: true,
                    id_tabela_versao: this.tabela.id_tabela_versao,
                },
                loadTo: res => {
                    this.lista_base_operadoras = res;
                }
            });

            $('#editVinculoOperadorasModal').modal('show');
        },

        fechar_modal(name = null) { 
            if ( name ) { 
                $('#' + name).modal('hide');
            } else { 
                $('.modal').modal('hide');
            }
        },

        vincular (tv) { 
            this.$refs.vinc.incluir (tv.id_tabela_versao);
        },

        copiar_moedas_de() { 
            if ( this.copia_origem ) { 
                this.removendo_moeda = true; 

                this.$util.load(this, { 
                    service: 'moedas',
                    func: 'index',
                    parms: { 
                        where: { 
                            id_tabela_versao: this.copia_origem,
                            fl_ativo: 1, 
                        }
                    },
                    loadTo: res => { 
                        res.forEach(moeda => { 
                            let outra = this.moedas.find(item => item.st_moeda == moeda.st_moeda);

                            if ( outra ) { 
                                outra.dc_valor = moeda.dc_valor;
                            } else { 
                                moeda.id_moeda = null;
                                moeda.id_tabela_versao = this.tabela.id_tabela_versao;

                                this.moedas.push(moeda);
                            }
                        });
                    }, 
                    final: () => { 
                        this.$nextTick(() => { 
                            this.removendo_moeda = false; 
                        });
                    }
                });

                this.copia_origem = null;

                this.$nextTick(() => { 
                    this.copia_origem = "";
                });
            }
        },

        marcar_todos_vinculo () { 
            const selec = this.lista_vincular.find(item => !item.selec) ? true : false;

            this.lista_vincular.forEach(item => { 
                item.selec = selec;
            });
        },

        lista_operadoras (tabela) { 
            return tabela.tabela_operadoras.map(item => item.operadora.st_operadora).sort().join(', ');
        },

        save_vinc_tuss() { 
            this.$refs.dispatchModal.executar_chunck(
                'tabelas',
                'save_vinc_tuss',
                this.lista_vincular_exibicao.filter(item => item.selec),
                'lista',
                {},
                100
            );

            /*
            this.$util.atualizar(this, { 
                service: 'tabelas',
                func: 'save_vinc_tuss',
                dados: { 
                    lista: this.lista_vincular.filter(item => item.selec), 
                },
                modal: 'vincularTUSSModal',
                callback: this.reloadItems, 
            });
            */
        },

        abrir_modal_vincular_tuss(tipo = 'T') { 
            this.lista_vincular = null;
            this.filtro_vinc = { 
                id_especialidade: "",
                id_classe_procedimento: "",
                pesquisa: "", 
            };
            
            $('#vincularTUSSModal').modal('show');

            this.$util.load(this, { 
                service: 'tabelas',
                func: 'lista_vinc_tuss',
                parms: { 
                    id_tabela_versao: this.tabela.id_tabela_versao, 
                    tipo: tipo, 
                },
                loadTo: res => { 
                    this.lista_vincular = res.map(item => { 
                        item.selec = true;
                        return item;
                    });
                }
            });
        },

        remover_moeda (moeda) { 
            if ( moeda.item_tabelas_count ) { 
                this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Moeda " + moeda.search + " com " + moeda.item_tabelas_count + 
                            ( moeda.item_tabelas_count == 1 
                                ? ' item relacionado.'
                                : ' itens relacionados' ),
                        life: 3000
                    });
                return;
            }

            if ( !confirm('Confirma a remoção da moeda: ' + moeda.st_moeda + '?') )
                return;

            this.removendo_moeda = true;

            this.$nextTick(() => { 
                moeda.fl_ativo = false;
                this.removendo_moeda = false;
            })
        },

        localizar_campo (index) { 
            return ( index < 0 ) ? "" : index;
        },

        // Importar Tabela...

        selecionar_base() { 
            $('.modal').modal('hide');

            $('#importBaseModal').modal('show');

            if ( !this.tabelas_base ) { 

                this.$util.load(this, { 
                    service: 'tabela_versaos', 
                    func: 'tabelas_base',
                    loadTo: res => { 
                        this.tabelas_base = res;
                    }
                });

            }
        },

        incluir_tabela_base(tabela) { 

            if ( !confirm('Confirma a inclusão da tabela ' + tabela.st_nome + '?') ) 
                return;
            
            this.incluindo_tabela_referencia = tabela;

            this.$util.atualizar(this, { 
                service: 'tabela_versaos', 
                func: 'incluir_tabela_base',
                dados: { 
                    id_tabela_versao: tabela.id_tabela_versao,
                },
                callback: () => { 
                    this.load();
                },
                final: () => { 
                    this.incluindo_tabela_referencia = null;
                },
                modal: 'importBaseModal',
            });

        },

        importar (incluir, chunks = null, total = null, proc = null) {

            let proximas = !( total === null );

            if ( !chunks ) { 
                chunks = _.chunk(this.importados, 100);
                total = chunks.length;
                proc = 0;
                this.perc_import = 0;
            }

            if ( !chunks || !chunks.length )
                return;

            let lista = chunks[0];

            chunks = _.slice(chunks, 1);
            
            this.$util.atualizar(this, { 
                service: 'tabela_versaos',
                func: 'importar',
                dados: { 
                    importados: lista,
                    campos: this.import_colunas,
                    id_tabela_versao: this.tabela.id_tabela_versao,
                    incluir: incluir, 
                    fixos: this.fixos,
                    proximas: proximas,  
                    import_descr_diferente: this.import_descr_diferente,
                },
                callback: () => { 
                    proc ++;

                    this.perc_import = Math.round( ( proc / total ) * 100 );

                    if ( chunks && chunks.length ) { 
                        this.importar(incluir, chunks, total, proc);
                    } else { 
                        this.perc_import = 100;
                        
                        this.viewMode = 'T';

                        this.$nextTick(() => { 
                            this.reloadItems();
                        });

                        $('.modal').modal('hide');
                    }
                },
            });

        },

        abrir_modal_importar() { 
            $('#arquivoImportarModal').modal('show');
        },

        upload() { 
            $('.modal').modal('hide');
            var downloadAnchorNode = document.createElement('input');
			downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.setAttribute("accept", ".csv");
            downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode); };
			document.body.appendChild(downloadAnchorNode); 
			downloadAnchorNode.click();
        },
        
        posUpload(el) { 
			var file = el.files[0];

			if (file) {

				this.importados = null;
                this.carregando = true;

                this.$nextTick(() => { 

                    var reader = new FileReader();

                    reader.readAsText(file, "UTF-8");

                    reader.onload = (evt) => {
                        CSV.readAll(evt.target.result, ';', dados => {
                            this.importados = dados;
                        });

                        if ( this.importados && this.importados.length ) { 
                            const first_blank = this.importados[0].findIndex(item => !item);

                            if ( first_blank > 0 )
                                this.importados = this.importados.map(item => item.slice(0, first_blank));
                        }

                        if ( this.importados && this.importados.length ) { 

                            this.import_colunas.st_codigo = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('CÓD') >= 0 || item.toUpperCase().indexOf('COD') >= 0
                                )
                            );

                            this.import_colunas.st_nome = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.indexOf('NOME') >= 0 || item.toUpperCase() == 'PROCEDIMENTO')
                            );

                            this.import_colunas.in_numero_auxiliares = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('AUX') >= 0) 
                            );

                            this.import_colunas.in_porte_anestesico = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('ANEST') >= 0) 
                            );

                            this.import_colunas.dc_filme = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('FILME') >= 0) 
                            );

                            this.import_colunas.dc_custo_operacional = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('OPER') >= 0 || item.toUpperCase() == 'CO'
                                )
                            );

                            this.import_colunas.dc_valor = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('VALOR') >= 0
                                ) 
                            );

                            this.import_colunas.id_moeda = this.localizar_campo( 
                                this.importados[0].findIndex(item => 
                                    item.toUpperCase().indexOf('MOEDA') >= 0 || item.toUpperCase() == 'PORTE'
                                ) 
                            );
                        }

                        /*
                st_codigo: "",
                st_nome: "",
                dc_valor: "",
                in_porte_anestesico: "",
                in_numero_auxiliares: "",
                dc_custo_operacional: "",
                dc_filme: "",
                id_moeda: "",
            },
            */

                        $('#importarModal').modal('show');

                        this.perc_import = null;
                        this.carregando = false;
                        
                        /*

                        if ( this.dados.length > 0 ) { 

                            if ( this.tem_cabecalho ) 
                                this.tratar_cabecalho(this.dados[0]);

                            this.exemplos = _.clone(
                                _.slice(this.dados, 1, 100)
                            );

                        }

                        this.carregando = false;
                        */

                    

                    }

                    reader.onerror = function () {
                        alert("Falha lendo arquivo.");
                        this.carregando = false;
                    }

                });

			} else { 

                alert('arquivo não encontrado.');

			}
		},

        //
        toggle_aplicar_todos() { 
            let aplicar = !this.marcar_todos;

            this.items.data.forEach(item => {
                item.aplicar = aplicar;
            });
        },

        efetivar_ajuste () { 

            if ( this.ajuste_item == 'plus' 
                || this.ajuste_item == 'minus' 
                || _.get(this.tabela, 'editar_coluna.coluna') == 'moeda' 
                || _.get(this.tabela, 'editar_coluna.coluna') == 'st_codigo' ) { 

                this.items.data.filter(item => item.aplicar)
                    .forEach(item => {
                        item.novo_valor = this.calc_valor_ajuste(item);
                    });
                    
            }

            this.$util.atualizar(this, { 
                service: 'tabela_versaos',
                func: 'ajustar_items',
                dados: { 
                    tabela: this.tabela,
                    items: this.items.data,
                    ajuste_item: this.ajuste_item,
                    ajustar_todos: this.ajustar_todos,
                    ajuste_data: this.ajuste_data, 
                    percentual_ajuste: this.percentual_ajuste, 
                    view_item_mode: this.viewItemMode,
                    ajuste_tabela: this.ajuste_tabela ? this.ajuste_tabela.id_tabela_versao : null, 
                },
                callback: this.reloadItems
            });

        },
        calc_valor_ajuste(item) { 
            if ( this.ajuste_item == 'tabela' || this.ajuste_item == 'tablink' ) { 
                if ( this.ajuste_tabela && this.ajuste_tabela.items ) {

                    let outra;

                    if ( ( this.tabela.editar_coluna.coluna == 'st_codigo' || this.ajuste_item == 'tablink' ) && item.procedimento_item_tabelas ) { 
                        let ids = item.procedimento_item_tabelas.map(pit => pit.id_procedimento);
                        console.log('ids', ids);
                        outra = this.ajuste_tabela.items.filter(outro => outro.vinculos.find(pit => ( ids.find(id => id == pit.id_procedimento)) ? true : false ));
                        console.log('outra', outra);
                    } else { 
                        outra = this.ajuste_tabela.items.filter(outro => outro.st_codigo == item.st_codigo);
                    }

                    if ( outra && outra.length ) { 
                        return _.get(
                            _.maxBy(outra, this.tabela.editar_coluna.coluna),
                            this.tabela.editar_coluna.coluna
                        );
                    }

                }

                return null;
            }

            return Math.round( 
                100 * item[this.tabela.editar_coluna.coluna] * 
                (
                    ( 
                    ( this.percentual_ajuste / 100 ) * ( this.ajuste_item == 'minus' ? -1 : 1 ) 
                    ) + 1
                )
            ) / 100;
        },
        editarColuna(coluna = null) { 
            this.validate = false;
            this.ajuste_data = null;
            this.ajuste_item = ( coluna && coluna.coluna == 'moeda' ? 'tabela' : 'edit' );
            this.percentual_ajuste = 0;

            if ( !coluna || this.tabela.editar_coluna && this.tabela.editar_coluna.coluna == coluna.coluna ) { 

                this.tabela.editar_coluna = null;

            } else { 

                this.tabela.editar_coluna = coluna;
    
            } 

            this.$forceUpdate();
        },
        clonar (clonar = true) { 
            this.edicaoTabela.novo_nome = this.edicaoTabela.st_nome;
            this.edicaoTabela.nova_versao = "";
            this.edicaoTabela.apenas_vinculados = 'V';
            this.edicaoTabela.clonar = clonar;
            this.edicaoTabela.editar_coluna = "";
        },

        tipoTabela (tabela, plural = true) { 
            let descricao;

            switch (tabela.st_aplicacao) {
                case 'PRO':
                    descricao = plural ? 'procedimentos' : 'procedimento';
                    break;

                case 'OUT':
                    descricao = plural ? 'taxas' : 'taxa';
                    break;

                case 'MAT':
                    descricao = plural ? 'materiais' : 'material';
                    break;

                case 'MED':
                    descricao = plural ? 'medicamentos' : 'medicamento';
                    break;

                case 'MIX':
                    descricao = plural ? 'materiais/medicamentos' : 'material/medicamento';
                    break;
            
                default:
                    break;
            }

            return descricao;

        },

        // Moedas...
        editarMoedas () { 
            this.moedas = null;
            $('#moedasModal').modal('show');
            
            this.$nextTick(() => { 
                this.moedas = _.cloneDeep (this.tabela.moedas);
            });
        },

        incluirMoeda () { 
            this.moedas.push({
                id_moeda: null, 
                id_tabela_versao: this.tabela.id_tabela_versao,
                st_moeda: "",
                dc_valor: 0,  
                excluido: false, 
                fl_ativo: true, 
            });
        },

        atualizarMoedas () { 
            this.$util.atualizar (this, { 
                service: 'moedas',
                func: 'stores',
                dados: { 
                    items: this.moedas,
                },
                modal: 'moedasModal',
                callback: this.reloadTabela,  
            });
        },

        // Tabela...
        atualizarTabela () { 
            if ( this.edicaoTabela.clonar ) { 
                if ( this.edicaoTabela.st_nome == this.edicaoTabela.novo_nome && this.edicaoTabela.st_versao == this.edicaoTabela.nova_versao ) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "A versão deve ser diferente.",
                        life: 3000
                    });

                    return;
                }
            }

            this.$util.atualizar(this, { 
                service: 'tabela_versaos',
                dados: this.edicaoTabela,
                modal: 'tabelaModal',
                callback: res => { 
                    if ( res.clone ) { 
                        this.load();
                        this.tabela = res.tabela_versao;
                    }

                    this.reloadTabela();  
                }
            })
        },
        reloadTabela () { 
            this.load ();
            this.editar (this.tabela);
        },
        incluirTabela () { 
            if ( !this.tipo ) { 
                alert ('Selecione o tipo de tabela.');
                return;
            }

            let tabela = {
                id_tabela_versao: null, 
                st_nome: "", 
                st_versao: "1",
                fl_ativo: true, 
                ch_tipo_tabela: "P",
                st_aplicacao: this.tipo, 
                fl_moeda_corrente: true, 
                fl_tem_imagem: false,
                fl_tem_cirurgia: false, 
                dc_valor_uco: 0,
                dc_valor_filme: 0,
            };

            this.editarTabela (tabela);
        },
        editarTabela (item) { 
            this.validate = false;

            this.edicaoTabela = null;

            this.$nextTick(() => { 
                this.edicaoTabela = { 
                    ...item,
                    clonar: false,
                };
                $('#tabelaModal').modal('show');
            });
        },
        // Items...
        buscarItems () { 
            if ( this.pesquisar_debounce )
                clearTimeout(this.pesquisar_debounce);

            this.pesquisar_debounce = setTimeout(() => {
                this.editar(this.tabela);
                clearTimeout(this.pesquisar_debounce);
            }, 1000);
        },
        incluirItem () { 
            this.$refs.cadtab.incluirItem (this.tabela, this.reloadItems);
        },
        editarItem (item) { 
            this.$refs.cadtab.abrirItemTabela (item.id_item_tabela ? item.id_item_tabela : item.id_propria, this.reloadItems, this.tabela);
        },
        atualizarItem () { 
            this.$util.atualizar(this, { 
                service: 'item_tabelas',
                dados: this.itemTabela,
                modal: 'itemModal',
                callback: this.reloadItems, 
            })
        },
        selecao_remover(item) { 
            if ( !confirm("Confirma a remoção do item '" + ( item.st_nome ? item.st_nome : item.st_descricao ) + "'?") )
                return;

            this.itemTabela = _.cloneDeep(item);
            this.removerItem();
        },

        removerItem () { 
            
            if ( this.itemTabela.id_propria ) { 
                
                this.$util.remover(this, { 
                    service: 'proprias',
                    dados: this.itemTabela, 
                    modal: 'itemModal',
                    callback: this.reloadItems, 
                });    

            } else { 

                this.$util.remover(this, { 
                    service: 'item_tabelas',
                    dados: this.itemTabela, 
                    modal: 'itemModal',
                    callback: this.reloadItems, 
                });

            }

        },
        reloadItems () { 
            this.editar (this.tabela, this.page);
        },
        // Listar Operadoras...
        listOperadoras (tabela) { 
            this.tabela = { ...tabela };
            $('#operadorasModal').modal('show');
        },
        // Listar Procedimentos...
        listProcedimentos (item) { 
            this.itemTabela = { ...item };

            let service = 'procedimento_item_tabelas';
            let withload = ['procedimento', 'item'];

            switch (this.tabela.st_aplicacao) {
                case 'OUT':
                    service = 'taxa_item_tabelas';
                    withload = ['taxa', 'item'];
                    break;

                case 'PRO':
                    withload = [
                        'procedimento.especialidade', 
                        'item.especialidade'
                    ];
                    break;

                case 'MIX':
                    return;
            
                default:
                    break;
            }

            this.$util.load(this, { 
                service: service,
                with: withload,
                parms: { 
                    with: withload,
                    where: { 
                        id_item_tabela: item.id_item_tabela,
                    }
                },
                loadTo: (dados) => { 
                    this.procedimentos = dados;
                    $('[data-toggle="tooltip"]').tooltip('dispose');
                    $('#procedimentosModal').modal('show');
                },
            });
        },
        //
        incluir () { 
            this.validate = false;

            let item = {
                id_pacote: null, 
                dc_valor: 0, 
                fl_ativo: true,
                fl_combo: false,
                procedimento_pacote: { 
                    in_quantidade: 2,
                    procedimento: null, 
                }
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let filtro = ( this.id_tabela_versao && this.link ) ? { id_tabela_versao: this.id_tabela_versao } : { st_aplicacao: this.tipo };  

            let query = { q: [
                { 
                    name: 'tabela_versaos.index',
                    id: 'lista',
                    parms: { 
                        where: { 
                            ...filtro,
                        },
                        cadastro: true,  
                        pesquisa: this.search,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;

                        if ( this.id_tabela_versao && this.dados && this.dados.length == 1 ) { 
                            this.tipo = this.dados[0].st_aplicacao;

                            this.$nextTick(() => { 
                                this.editar (this.dados[0]); 
                            });
                        }
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        paginar (page, size = 10) {
            this.reloading = true;
            this.editar(this.tabela, page, size);
        },
        buscar_items_ajuste_tabela () { 

            if ( !this.ajuste_tabela ) { 
                return;
            }

            if ( this.tabela.editar_coluna.coluna == 'st_codigo' || this.ajuste_item == 'tablink' ) { 

                this.$util.loadItem(this, { 
                    service: 'item_tabelas',
                    func: 'index',
                    parms: { 
                        id_tabela_versao: this.ajuste_tabela.id_tabela_versao,
                        id_procs: this.items.data.flatMap(item => item.procedimento_item_tabelas 
                            ? item.procedimento_item_tabelas.map(pit => pit.id_procedimento)
                            : []),
                    }
                })
                .then(res => { 
                    this.ajuste_tabela.items = res;
                    this.$nextTick(() => { 
                        this.$forceUpdate();
                    });
                });

            } else { 

                this.$util.loadItem(this, { 
                    service: 'item_tabelas',
                    func: 'index',
                    parms: { 
                        id_tabela_versao: this.ajuste_tabela.id_tabela_versao,
                        codigos: this.items.data.map(item => item.st_codigo),
                    }
                })
                .then(res => { 
                    this.ajuste_tabela.items = res;
                    this.$nextTick(() => { 
                        this.$forceUpdate();
                    });
                });

            }

        },
        preco_programado (item) {
            if ( item.item_tabela_preco && item.item_tabela_preco.fl_ativo && item.item_tabela_preco.dt_vigencia_inicio > this.$util.hoje() ) { 
                return this.$util.formatMoeda(item.item_tabela_preco.dc_valor) + ' a partir de ' + 
                    this.$util.getFormatDate(item.item_tabela_preco.dt_vigencia_inicio);
            }

            return "";
        },

        editar (item, page = 1, size = 10) { 
            this.validate = false;

            if ( this.tipo != 'PRO' ) {
                this.especialidade = "";
            }
            
            this.$store.commit('loading', true);

            let filtro = {}

            if ( this.id_item_tabela ) { 
                filtro = { 
                    where: { 
                        id_item_tabela: this.id_item_tabela,
                    } 
                };
            }

            let vinc = this.viewItemMode == 'N' ? 'N' : ( this.viewItemMode == 'V' ? true : false );

            // console.log('vinc', vinc);

            this.page = page;

            let query = { q: [
                { 
                    name: 'tabela_versaos.index',
                    id: 'tabelas',
                    parms: { 
                        cadastro_procedimento: true
                    }
                },
                { 
                    name: 'tabela_versaos.show',
                    id: 'tabela', 
                    parms: { 
                        id: item.id_tabela_versao, 
                    }
                },
                { 
                    name: item.st_aplicacao == 'MIX' ? 'proprias.index' : 'item_tabelas.index',
                    id: 'items', 
                    parms: { 
                        search: this.searchItem, 
                        ativos: this.viewItemModeAtivo == 'T' ? false : true,
                        cadastro: true, 
                        vinculados: vinc, 
                        id_tabela_versao: item.id_tabela_versao,
                        id_especialidade: this.especialidade ? this.especialidade.id_especialidade : null,
                        tipo_tabela: item.st_aplicacao, 
                        page: page, 
                        size: size, 
                        ...filtro, 
                    }
                },

            ]};

            this.axios.post ('/aql?a=tabela_versaos.show', query)
                .then(res => { 

                    if ( res.data.tabelas.status == 200 ) { 
                        this.lista_tabelas = res.data.tabelas.data;
                    }

                    if ( res.data.tabela.status == 200 && !this.reloading ) { 
                        this.tabela = res.data.tabela.data;
                        this.item = res.data.tabela.data;

                        this.tabela.tabela_operadoras = _.orderBy(this.tabela.tabela_operadoras, 'operadora.st_operadora');
                    }

                    if ( res.data.items.status == 200 ) { 

                        res.data.items.data.data = res.data.items.data.data.map(item => { 
                            item.aplicar = false;
                            item.novo_valor = "";
                            return item;
                        });

                        this.items = res.data.items.data;

                        this.items.data = this.items.data.map(item => { 
                            if ( item.item_tabela_preco && item.item_tabela_preco.fl_ativo && item.item_tabela_preco.dt_vigencia_inicio <= this.$util.hoje() ) { 
                                item.dc_valor = item.item_tabela_preco.dc_valor;
                            }

                            return item;
                        });

                        this.em_edicao = true;

                        if ( this.tabela.search ) { 
                            let bc = _.cloneDeep(this.breadcrumb);
                            bc.push({ name: this.item.search, path: "" });
                            this.$store.commit('setBreadcrumb', bc);

                            if ( this.$route.path != '/config/tabelas/' + this.tabela.id_tabela_versao ) { 

                                this.$router.replace({ 
                                    name: 'c-tabelas', 
                                    params: { 
                                        id_tabela_versao: this.tabela.id_tabela_versao,
                                    }
                                });

                            }
                        }
                    }

                })
                .finally (() => { 
                    this.$store.commit('loading', false);
                    this.reloading = false;
                });

        },
        fechar () { 
            if ( this.id_tabela_versao && this.link ) { 
                this.$router.go(-1);
            } else { 
                if ( this.$route.path != '/config/tabelas' ) { 

                    this.$router.replace({ 
                            name: 'c-tabelas'
                        });

                }

                this.em_edicao = false;
                this.$store.commit('setBreadcrumb', this.breadcrumb);
                window.scrollTo(0,0);
            }
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'tabela_versaos.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        if ( this.id_tabela_versao ) 
            this.link = true;

        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Tabelas", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
